import { gql } from '@apollo/client';
import type {
    InhubDataFreshness,
    InhubSortingMetric,
    InhubWowSeverity
} from '../types';

export const GET_INHUB_SORTING_KPI_SUMMARY = gql`
  query GetInhubSortingKpiSummary($filter: InhubDashboardRangeInput!) {
    getInhubSortingKpiSummary(filter: $filter) {
      cells {
        metric
        value
        wowPercent
        freshness
        severity
        isNegativeIndicator
      }
      dataCalculatedAtMax
      thresholds {
        warnWowPercent
        dangerWowPercent
      }
    }
  }
`;

export interface InhubDashboardRangeInput {
    hubId: number;
    rangeStart: string;
    rangeEnd: string;
}

export interface InhubKpiCellResp {
    metric: InhubSortingMetric;
    value: number;
    wowPercent: number;
    freshness: InhubDataFreshness;
    severity: InhubWowSeverity;
    isNegativeIndicator: boolean;
}

export interface InhubSeverityThresholdsResp {
    warnWowPercent: number;
    dangerWowPercent: number;
}

export interface GetInhubSortingKpiSummaryResponse {
    getInhubSortingKpiSummary: {
        cells: InhubKpiCellResp[];
        dataCalculatedAtMax: string | null;
        thresholds: InhubSeverityThresholdsResp;
    };
}
